import {
  BodySubstitutionPartsListParams,
  BodySubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySubstitutionPartsList/getBodySubstitutionPartsListQuery.type';
import { BodySubstitutionPartsListQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodySubstitutionPartsList/getBodySubstitutionPartsListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodySubstitutionPartsListQueryOptions = (
  params: BodySubstitutionPartsListParams,
) =>
  queryOptions({
    queryKey: ['get_body_substitution_parts_list', params],
    queryFn: () => BodySubstitutionPartsListQueryFunction(params),
    select: (data: BodySubstitutionPartsListResponse) => {
      return {
        count: data?.count,
        total_price: data?.total_price,
        substitution: data?.substitution?.map((item) => ({ ...item })),
        id: data?.substitution?.map((item) => ({ id: item?.id })),
        cartData: data?.substitution?.map((item) => [
          {
            name: 'نام قطعه :',
            value: item?.part_name,
          },
          {
            name: 'قیمت :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.part_price)} ریال`,
          },
          {
            name: 'ارزش داغی :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.daghi_price)} ریال`,
          },
          {
            name: 'اجرت تعمیرات :',
            value: `${new Intl.NumberFormat('fa-IR').format(+item?.wage_price)} ریال`,
          },
          {
            name: 'میزان تصادف :',
            value: item?.accident_level_fa,
          },
        ]),
      };
    },
  });
